<template>
  <yams-template>
    <template #header>
      <div class="mr-5">
        <h4 class="text-primary font-weight-bold">Pieces de caisse ({{ lines }})</h4>
      </div>
      <div class="mr-4">
        <NavComptabilite></NavComptabilite>
      </div>
      <div class="btn-group page-nav mr-4" role="group" aria-label="Basic example">
        <button type="button" class="btn " @click.prevent="changeAffichage('table')"
          :class="{ 'active': affichage === 'table' }">
          <i class="fa-solid fa-bars"></i>
        </button>
        <button type="button" class="btn " @click.prevent="changeAffichage('card')"
          :class="{ 'active': affichage === 'card' }">
          <i class="fa-solid fa-border-all"></i>
        </button>
      </div>
      <div class="px-1">
        <button type="button" class="btn-yams btn-active" @click="openCreateModal()">
          Ajouter une piece de caisse <i class="fa-solid fa-plus"></i>
        </button>
      </div>
    </template>
    <template #content>
      <div class="card mb-5">
        <div class="card-body p-1">
          <DataTableBackend :key="key" url="/api/piece_de_caisses" :columns="columns" :view-mode="affichage"
            :table="table" @row-click="openShowModal" @set-selected-rows="getSelection"
            v-on:set-total-records="updateLines">
          </DataTableBackend>
        </div>
      </div>
    </template>
  </yams-template>
</template>

<script>
import $ from "jquery"
import { defineComponent } from 'vue';
import FormPieceDeCaisse from "@/views/comptabilite/pieces-de-caisse/FormPieceDeCaisse.vue";
import ShowPieceDeCaisse from '@/views/comptabilite/pieces-de-caisse/ShowPieceDeCaisse.vue';
import NavComptabilite from '@/views/comptabilite/NavComptabilite.vue'

export default defineComponent({
  components: { NavComptabilite },
  name: 'IndexCaisse',
  data() {
    return {
      lines: 0,
      key: 1,
      affichage: "table",
      isLoading: true,
      table: 'piece_de_caisses',

      columns: [
        {
          key: 'date_operation',
          label: 'Prise d\'effet',
          format: 'date',
          exportable: true
        },
        {
          key: 'libelle',
          label: 'Libelle',
          exportable: true,
          sortable: true
        },
        {
          key: 'beneficiaire',
          label: 'Bénéficiare',
          exportable: true,
          sortable: true
        },
        {
          key: 'decaisseur',
          label: 'Décaisseur',
          exportable: true,
          sortable: true
        },
        {
          key: 'montant',
          label: 'Montant',
          format: 'money',
          exportable: true,
          sortable: true
        }
      ]
    };
  },
  methods: {
    changeAffichage(type) {
      this.affichage = type;
      this.key++
    },
    getSelection(selection) {
      this.selection = selection
    },
    openShowModal(objData) {
      this.$dialog.open(ShowPieceDeCaisse, {
        props: {
          header: "Piece de caisse ID" + objData.id,
          style: {
            width: '50vw'
          },
          modal: true
        },
        data: objData
      });
    },
    openCreateModal() {
      this.$dialog.open(FormPieceDeCaisse, {
        props: {
          header: "Nouvelle piece de caisse",
          style: {
            width: '50vw'
          },
          modal: true
        }
      });
    },
    deleteGroup(selection) {
      if (!window.confirm("Etes vous sur de vouloir supprimer ?")) {
        return
      }

      this.isLoading = true
      let selectedLines = []
      for (let index = 0; index < selection.length; index++) {
        const element = selection[index];
        selectedLines.push(element.id)
      }

      this.axios.post('/api/caisses/destroy-group', { selected_lines: selectedLines }).then((response) => {
        this.isLoading = false
        if (response.data.success === true) {
          $('#refresh' + this.table).click()
          for (let index = 0; index < response.data.message.length; index++) {
            const element = response.data.message[index];
            this.$toast.add({
              severity: element.severity,
              detail: element.value,
              life: parseInt(5000 * (index + 1))
            });
          }
        }
      }).catch(() => {
        this.isLoading = false
        this.$toast.add({
          severity: 'error',
          summary: 'Probleme de connexion',
          detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
          life: 5000
        });
      })
    },
    updateLines(nb_lines) {
      this.lines = nb_lines
    }
  },

});
</script>